// // src/components/Hero.js
// import React from 'react';
// import "../components/Hero.css"  // Import Hero CSS

// const Hero = () => {
//   return (
//     <div className="hero-container">
//       <div className="hero-text">
//         <h1>Never Miss Your Medicine Again</h1>
//         <p>
//           Your personal medicine reminder that keeps you healthy and on track.
//           Simple, reliable, and always there when you need it.
//         </p>
//         <div className="countdown">
//           <div className="countdown-item">
//             <span className="countdown-time">15</span>
//             <p>Days</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">08</span>
//             <p>Hours</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">45</span>
//             <p>Minutes</p>
//           </div>
//         </div>
//         <div className="buttons">
//           <a href="https://www.apple.com/app-store/" target="_blank" className="btn">
//             <img src='../assets/appStore.png'/>
            
//           </a>
//           <a href="https://play.google.com/store" target="_blank" className="btn">
//             Google Play
//           </a>
//         </div>
//       </div>
//       <div className="hero-image">
//         <img src="path-to-your-image.png" alt="App Preview" />
//       </div>
     
//     </div>
    
    
//   );
// };

// export default Hero;


// src/pages/Hero.js
// import React from 'react';
// import '../components/Hero.css';  // Import CSS for styling
// import appStoreImage from '../assets/appStore.png';  // Import image from assets folder
// import googlestoreImage from '../assets/playStore.png';
// import first from '../assets/first.png';

// const Hero = () => {
//   return (
//     <div className="hero-container">
//       <div className="hero-text">
//         <h1>Never Miss Your Medicine Again</h1>
//         <p>Your personal medicine reminder that keeps you healthy and on track. Simple, reliable, and always there when you need it.</p>
//         <div className="countdown">
//           <div className="countdown-item">
//             <span className="countdown-time">15</span>
//             <p>Days</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">08</span>
//             <p>Hours</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">45</span>
//             <p>Minutes</p>
//           </div>
//         </div>
//         <div className="buttons">
//           <a href="https://www.apple.com/app-store/" target="_blank" className="btn">
//             <img src={appStoreImage} alt="App Store" />
//           </a>
//           <a href="https://play.google.com/store" target="_blank" className="btn">
//             <img src={googlestoreImage} alt='Play Store'/>
//           </a>
//         </div>
//       </div>
//       <div className="hero-image">
//         <img src={first} alt="App Preview" />
//       </div>
//     </div>
//   );
// };

// export default Hero;




// import React, { useState, useEffect } from 'react';
// import '../components/Hero.css';  // Import CSS for styling
// import appStoreImage from '../assets/appStore.png';  // Import image from assets folder
// import googlestoreImage from '../assets/playStore.png';
// import first from '../assets/first.png';

// const Hero = () => {
//   // Set the target launch date for the countdown (example: April 1st, 2025)
//   const targetDate = new Date("2025-04-01T00:00:00").getTime();

//   const [timeLeft, setTimeLeft] = useState({
//     days: 0,
//     hours: 0,
//     minutes: 0,
//   });

//   useEffect(() => {
//     const interval = setInterval(() => {
//       // Calculate the difference between current time and target date
//       const now = new Date().getTime();
//       const difference = targetDate - now;

//       if (difference <= 0) {
//         clearInterval(interval); // Stop the interval when countdown is over
//         setTimeLeft({ days: 0, hours: 0, minutes: 0 });
//       } else {
//         // Calculate time components
//         const days = Math.floor(difference / (1000 * 60 * 60 * 24));
//         const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//         const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

//         setTimeLeft({ days, hours, minutes });
//       }
//     }, 60000); // Update the countdown every minute (60,000 ms)

//     return () => clearInterval(interval); // Cleanup on component unmount
//   }, [targetDate]);

//   return (
//     <div className="hero-container">
//       <div className="hero-text">
//         <h1>Never Miss Your Medicine Again</h1>
//         <p>Your personal medicine reminder that keeps you healthy and on track. Simple, reliable, and always there when you need it.</p>
//         <div className="countdown">
//           <div className="countdown-item">
//             <span className="countdown-time">{timeLeft.days}</span>
//             <p>Days</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">{timeLeft.hours}</span>
//             <p>Hours</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">{timeLeft.minutes}</span>
//             <p>Minutes</p>
//           </div>
//         </div>
//         <div className="buttons">
//           <a href="https://www.apple.com/app-store/" target="_blank" className="btn">
//             <img src={appStoreImage} alt="App Store" />
//           </a>
//           <a href="https://play.google.com/store" target="_blank" className="btn">
//             <img src={googlestoreImage} alt="Google Play" />
//           </a>
//         </div>
//       </div>
//       <div className="hero-image">
//         <img src={first} alt="App Preview" />
//       </div>
//     </div>
//   );
// };

// export default Hero;



// import React, { useState, useEffect } from 'react';
// import '../components/Hero.css';  // Import CSS for styling
// import appStoreImage from '../assets/appStore.png';  // Import image from assets folder
// import googlestoreImage from '../assets/playStore.png';
// import first from '../assets/first.png';

// const Hero = () => {
//   // Set the target launch date (April 1st, 2025)
//   const targetDate = new Date("2025-04-01T00:00:00").getTime();

//   const [timeLeft, setTimeLeft] = useState({
//     days: 0,
//     hours: 0,
//     minutes: 0,
//     seconds: 0,
//   });

//   // Update the countdown every second
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const now = new Date().getTime();
//       const difference = targetDate - now;

//       if (difference <= 0) {
//         clearInterval(interval); // Stop the interval once the countdown is over
//         setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
//       } else {
//         // Calculate time components
//         const days = Math.floor(difference / (1000 * 60 * 60 * 24));
//         const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//         const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
//         const seconds = Math.floor((difference % (1000 * 60)) / 1000);

//         setTimeLeft({ days, hours, minutes, seconds });
//       }
//     }, 1000); // Update the countdown every second (1000 ms)

//     return () => clearInterval(interval); // Cleanup when the component is unmounted
//   }, [targetDate]);

//   return (
//     <div className="hero-container">
//       <div className="hero-text">
//         <h1>Never Miss Your Medicine Again</h1>
//         <p>Your personal medicine reminder that keeps you healthy and on track. Simple, reliable, and always there when you need it.</p>
//         <div className="countdown">
//           <div className="countdown-item">
//             <span className="countdown-time">{timeLeft.days}</span>
//             <p>Days</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">{timeLeft.hours}</span>
//             <p>Hours</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">{timeLeft.minutes}</span>
//             <p>Minutes</p>
//           </div>
//           <div className="countdown-item">
//             <span className="countdown-time">{timeLeft.seconds}</span>
//             <p>Seconds</p>
//           </div>
//         </div>
//         <div className="buttons">
//           <a href="https://www.apple.com/app-store/" target="_blank" className="btn">
//             <img src={appStoreImage} alt="App Store" />
//           </a>
//           <a href="https://play.google.com/store" target="_blank" className="btn">
//             <img src={googlestoreImage} alt="Google Play" />
//           </a>
//         </div>
//       </div>
//       <div className="hero-image">
//         <img src={first} alt="App Preview" />
//       </div>
//     </div>
//   );
// };

// export default Hero;





import React, { useState, useEffect } from 'react';
import '../components/Hero.css';  // Import CSS for styling
import appStoreImage from '../assets/appStore.png';  // Import image from assets folder
import googlestoreImage from '../assets/playStore.png';
import first from '../assets/first.png';

const Hero = () => {
  // Set the target launch date (May 15th, 2026)
  const targetDate = new Date("2026-05-15T00:00:00").getTime();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Update the countdown every second
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference <= 0) {
        clearInterval(interval); // Stop the interval once the countdown is over
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        // Calculate time components
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      }
    }, 1000); // Update the countdown every second (1000 ms)

    return () => clearInterval(interval); // Cleanup when the component is unmounted
  }, [targetDate]);

  return (
    <div className="hero-container">
      <div className="hero-text">
        <h1>Never Miss Your Medicine Again</h1>
        <p>Your personal medicine reminder that keeps you healthy and on track. Simple, reliable, and always there when you need it.</p>
        <div className="countdown">
          <div className="countdown-item">
            <span className="countdown-time">{timeLeft.days}</span>
            <p>Days</p>
          </div>
          <div className="countdown-item">
            <span className="countdown-time">{timeLeft.hours}</span>
            <p>Hours</p>
          </div>
          <div className="countdown-item">
            <span className="countdown-time">{timeLeft.minutes}</span>
            <p>Minutes</p>
          </div>
          <div className="countdown-item">
            <span className="countdown-time">{timeLeft.seconds}</span>
            <p>Seconds</p>
          </div>
        </div>
        <div className="buttons">
          <a href="https://www.apple.com/app-store/" target="_blank" className="btn">
            <img src={appStoreImage} alt="App Store" />
          </a>
          <a href="https://play.google.com/store" target="_blank" className="btn">
            <img src={googlestoreImage} alt="Google Play" />
          </a>
        </div>
      </div>
      <div className="hero-image">
        <img src={first} alt="App Preview" />
      </div>
    </div>
  );
};

export default Hero;